import { render } from "./TemplateSTR.vue?vue&type=template&id=e8f77588"
import script from "./TemplateSTR.vue?vue&type=script&lang=js"
export * from "./TemplateSTR.vue?vue&type=script&lang=js"
script.render = render

export default script